﻿let districts = [
    'Адмиралтейский', 'Василеостровский', 'Выборгский', 'Калининский', 'Кировский', 'Колпинский',
    'Красногвардейский', 'Красносельский', 'Кронштадтский', 'Курортный', 'Московский', 'Невский', 'Петроградский',
    'Петродворцовый', 'Приморский', 'Пушкинский', 'Фрунзенский', 'Центральный'
];

export default districts;
